import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InToolsService } from '../../../shared/services/inventory/in-tools.service'

export interface SerialModel {
  title: string;
  item:ItemDtls;
  data: SerialNoTrack_Master[];
}
@Component({
  selector: 'app-serialnumbertrack',
  templateUrl: './serialnumbertrack.component.html',
  styleUrls: ['./serialnumbertrack.component.css'], 
})

export class SerialNumberTrackComponent extends DialogComponent<SerialModel, boolean> implements SerialModel, OnInit {
  title: string;
  data: SerialNoTrack_Master[]=[] ;
  result: any = { result: false, data: [] };
  loading: boolean = false;
  itemCount:number=0;
  cols: any[];
  item:ItemDtls=new ItemDtls();
  SerialNoList:SerialNoBarcode[]=[];
  ShowTextBox:boolean=true ;
  constructor(dialogService: DialogService,private ts: InToolsService) { super(dialogService); }

  ngOnInit() {
   this.itemCount=this.item.Qty;
   this.getSerialNumberByBarcode();
   if(this.item.Type==8 || this.item.Type==10){
    // this.cols = [
    //   { field: 'SlNo', header: 'SlNo.', t: 'text', f: 'text' ,w: "80px",Align: 'left' },
    //   { field: 'SerialNo', header: 'Serial Number', t: 'text', f: 'select',w: "200px" ,Align: 'left' },
    //   { field: 'Action', header: 'Action', t: 'btn', f: 'detbtn' ,w: "60px",Align: 'center'  },
    // ];
    this.ShowTextBox=false;
   }
   else{
    // this.cols = [
    //   { field: 'SlNo', header: 'SlNo.', t: 'text', f: 'text' ,w: "80px",Align: 'left' },
    //   { field: 'SerialNo', header: 'Serial Number', t: 'text', f: 'input',w: "200px" ,Align: 'left' },
    //   { field: 'Action', header: 'Action', t: 'btn', f: 'detbtn' ,w: "60px",Align: 'center'  },
    // ];
    this.ShowTextBox=true;
   } 
}

  Update() {
    if(this.validateSerial()){
      this.result = { result: true,data: this.data}
      this.close();
    }
  }

  validateSerial():boolean{
    if(this.itemCount!=this.data.length){
      alert("TotalS quantity("+this.itemCount+") and serial numbers not matching");
      return false;
    }
    for(let i of this.data){
      if(i.SerialNo==""){
       alert("Please enter Serial Number");
       return false;
      }

      if(this.ShowTextBox==false){
      if (!this.SerialNoList.find(item => item.SerialNo === i.SerialNo)) {
        alert("Invalid Serial Number "+ i.SerialNo);
        var key="SerialNo"+Number(i.SlNo).toString()
        document.getElementById(key).focus();
        return false;
     }
    }

    }
    return true;
  }

  removeSerialNumber(x) {
    var confMsg = confirm("Do you want to delete this Record?");
    if (confMsg == true) {
      this.data.splice(x, 1);
      var cnt=1;
      for(let i of this.data){
          i.SlNo=cnt;
          cnt=cnt+1;
      }
    }
  }

  SerialNoKeydown(e,i){
    if (e.keyCode == 13 && e.which == 13) {
      if(this.ShowTextBox==false){
        if (!this.SerialNoList.find(item => item.SerialNo === i.SerialNo)) {
           alert("Invalid Serial Number "+ i.SerialNo);
           i.SerialNo="";
           var key="SerialNo"+Number(i.SlNo).toString()
          document.getElementById(key).focus();
           return;
        }
      }

      if(this.data.length>=i.SlNo+1){
        if(i.SerialNo!=undefined && i.SerialNo!=""){
          var key="SerialNo"+Number(i.SlNo+1).toString()
          document.getElementById(key).focus();
        }      
      }   
    }

  }

  getSerialNumberByBarcode() {
    if(this.item.Type==8 || this.item.Type==10){
      var data = {
        Barcode: this.item.Barcode,
        LocId: this.item.LocId
      }
      this.loading = true;
      this.ts.Get_SerialNumberByBarcode(data).subscribe(res => {
        if (res.Success) {
          for(let i of res.data){
            if(i.Qty>0){
              this.SerialNoList.push(i); 
            }    
          }
          this.loading = false;
        }
        else {
          this.SerialNoList =[];
          this.loading = false;
        }
      })
    }     
  }

}

class SerialNoTrack_Master {
  SerialNo: string = "";
  SlNo: number = 0;
}

class ItemDtls{
  Barcode:string=""
  Itemname:string=""
  Qty:number=0
  Unit:string=""
  LocId:number=0
  Type:number=0
}

class SerialNoBarcode {
  Barcode: string = "";
  SerialNo: string = "";
  Qty:number=0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/serialnumbertrack/serialnumbertrack.component.ts